import React, { useEffect, useMemo, useState } from 'react';
import useStateManager from '../../../components/hooks/useStateManager';
import { Button } from '@mui/material';
import EngageModal from './engageModal';
import { CheckCircle, MenuBook } from '@mui/icons-material';
import AssignmentForm from 'components/AdminBooks/AssignmentForm';
import { handleAdminDeleteEnageActivity } from 'store/activities/thunks';
import { useDispatch } from 'react-redux';
import { useUI } from 'store/UI/selectors';
import { updateUI } from 'store/UI/actions';
import { captureException } from '@sentry/react';
import { useFirebase } from 'containers/FirebaseContext';
import { deleteDoc, doc } from 'firebase/firestore';
import BadgeButton from 'components/AdminBooks/BadgeButton';

const ToolBarEngageMentAdmin = ({
  page,
  bookId,
  pageId,
  pgEngage,
  onRemoveEngage,
  onChangeEngage,
  filteredQuizAndActivityEngagement,
  subTopics,
}) => {
  const { openEngageModal = false } = useUI();
  const dispatch = useDispatch();
  const [draftId, setDraftId] = useState(null);
  const { firestore } = useFirebase();
  const [states, updateState] = useStateManager({
    loading: { type: '', value: '' },
    activityDrawer: false,
  });
  const [showOptions, setShowOptions] = useState("units");


  const onChangeImage = (data) => {
    onChangeEngage(data);
  };

  const onChangeAssignment = async (data) => {
    dispatch(updateUI({ openEngageModal: false }));
    updateState({ activityDrawer: true, sequence_id: data?.id });
  };

  const onRemove = (data) => {
    onRemoveEngage(data);
    dispatch(
      handleAdminDeleteEnageActivity({
        book: bookId,
        page: pageId,
      }),
    );
  };

  useEffect(() => {
    try {
      const checkAssignmentDrawer = setInterval(() => {
        const assignmentDrawer = document.querySelector('.assignments-drawer');
        const engageModal = document.querySelector('.engage-modal');

        if (assignmentDrawer && engageModal) {
          engageModal.style.display = 'none';
        } else {
          if (engageModal) {
            engageModal.style.display = 'block';
          }
        }
      }, 100);
      return () => clearInterval(checkAssignmentDrawer);
    } catch (e) {
      captureException(e);
    }
  }, []);

  const pageCoverEngage = useMemo(() => {
    if(states.sequence_id){
      const findImageData = pgEngage?.imageData?.find(item => item.id === states.sequence_id);
      if(findImageData){
        return findImageData.resource;
      }
    }
    return null;
  }, [pgEngage,states.sequence_id]);

  const pageIswhere = useMemo(() => {
    const result = {
      units: false,
      subUnits: false,
      subLesson: false,
      unitIndex: null,
      subUnitIndex: null,
      subLessonIndex: null,
      unitLabel: null,
      subUnitLabel: null,
      subLessonLabel: null,
    };

    if (!subTopics || !Array.isArray(subTopics) || !pageId) {
      return result;
    }

    const pageNum = Number(pageId);

    for (let unitIndex = 0; unitIndex < subTopics.length; unitIndex++) {
      const unit = subTopics[unitIndex];
      const startPage = Number(unit.startPage);
      const finishPage = Number(unit.finishPage);

      if (pageNum >= startPage && pageNum <= finishPage) {
        result.units = true;
        result.unitIndex = unitIndex;
        result.unitLabel = unit?.shortName || unit?.label || null;

        if (unit.subUnits && Array.isArray(unit.subUnits)) {
          for (let subUnitIndex = 0; subUnitIndex < unit.subUnits.length; subUnitIndex++) {
            const subUnit = unit.subUnits[subUnitIndex];
            const subUnitStart = Number(subUnit.start);
            const subUnitFinish = Number(subUnit.finish);

            const isPageInSubUnit = pageNum >= subUnitStart && pageNum <= subUnitFinish;
            
            if (isPageInSubUnit) {
              result.subUnits = true;
              result.subUnitIndex = subUnitIndex;
              result.subUnitLabel = subUnit?.label || null;
            }

            if (subUnit.subLessons && Array.isArray(subUnit.subLessons)) {
              for (let subLessonIndex = 0; subLessonIndex < subUnit.subLessons.length; subLessonIndex++) {
                const subLesson = subUnit.subLessons[subLessonIndex];
                const subLessonStart = Number(subLesson.start);
                const subLessonFinish = Number(subLesson.finish);

                if (pageNum >= subLessonStart && pageNum <= subLessonFinish) {
                  result.subLesson = true;
                  result.subLessonIndex = subLessonIndex;
                  result.subLessonLabel = subLesson?.label || null;
                  break;
                }
              }
            }

            if (result.subLesson) {
              break;
            }
          }
        }
        break;
      }
    }

    return result;
  }, [subTopics, pageId]);

  useEffect(() => {
    if(pgEngage?.showOptions){
      setShowOptions(pgEngage?.showOptions);
    }else{
      setShowOptions("units");
    }
  }, [pgEngage]);

  return (
    <>
      <BadgeButton
        color="primary"
        onClick={() => {
          dispatch(updateUI({ openEngageModal: true }));
        }}
        ackgroundColor="#61a37d"
        startIcon={pgEngage && Object.keys(pgEngage).length > 0 ? <CheckCircle /> : <MenuBook />}
      >
        Engage Page
      </BadgeButton>

      <AssignmentForm
        pageSrc={pageCoverEngage}
        bookId={bookId}
        pageId={pageId}
        data={null}
        onCreateOrUpdate={() => {
          updateState({ activityDrawer: false });
          dispatch(updateUI({ openEngageModal: true }));
        }}
        type={'activity'}
        draftId={null}
        setDraftId={() => {}}
        open={states.activityDrawer}
        onClose={() => {
          updateState({ activityDrawer: false });
          dispatch(updateUI({ openEngageModal: true }));
        }}
        configEngageMent={{
          isFrom: 'engagement',
          sequence_order: states?.sequence_id,
          engage_id: pgEngage?.id || '',
        }}
        isDisableDraft={true}
        pageCoverEngage={pageCoverEngage}
      />
      <EngageModal
        pageId={pageId}
        bookId={bookId}
        open={openEngageModal}
        onClose={() => dispatch(updateUI({ openEngageModal: false }))}
        onChangeImage={onChangeImage}
        onRemove={onRemove}
        onChangeAssignment={onChangeAssignment}
        data={pgEngage}
        filteredQuizAndActivityEngagement={filteredQuizAndActivityEngagement}
        page={page}
        pageIswhere={pageIswhere}
        showOptions={showOptions}
        setShowOptions={(value) => {
          onChangeEngage({ ...pgEngage, showOptions: value });
          setShowOptions(value);
        }}

      />
    </>
  );
};

export default React.memo(ToolBarEngageMentAdmin);
